var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-container svg-arrow"},[_c('svg',{attrs:{"viewBox":"0 0 44.45 34"}},[_c('path',{staticClass:"svg-inner",attrs:{"d":"M31.5.5h-9s5.3,11,6.93,12H.5v9H29.43c-1.63,1-6.93,12-6.93,12h9s4.61-11,12.1-16.5h0C36.11,11.49,31.5.5,31.5.5Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }